import { render } from "./ProssingTwo.vue?vue&type=template&id=81c23b32&scoped=true"
import script from "./ProssingTwo.vue?vue&type=script&lang=js"
export * from "./ProssingTwo.vue?vue&type=script&lang=js"

import "./ProssingTwo.vue?vue&type=style&index=0&id=81c23b32&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81c23b32"]])

export default __exports__